import { render, staticRenderFns } from "./ResultPublicityDetail.vue?vue&type=template&id=8be70484&scoped=true&"
import script from "./ResultPublicityDetail.vue?vue&type=script&lang=js&"
export * from "./ResultPublicityDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultPublicityDetail.vue?vue&type=style&index=0&id=8be70484&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be70484",
  null
  
)

export default component.exports